import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import { getFormattedCurrency } from '@utils/formatter'

import { ContentProps, ProductDetailType } from './Content.interface'

const getMinimumGuaranteedCreditLimitValue = ({
    creditCard,
    category,
}: ContentProps) => {
    if (
        category === CreditCardProductCategory.BalanceTransfer &&
        creditCard.balanceTransferComboLimit
    ) {
        return creditCard.balanceTransferComboLimit
    }
    if (
        creditCard.balanceTransferComboLimit &&
        creditCard.guaranteedRate.guaranteedCreditLimit
    ) {
        return (
            creditCard.balanceTransferComboLimit +
            creditCard.guaranteedRate.guaranteedCreditLimit
        )
    }
    return creditCard.guaranteedRate.guaranteedCreditLimit
}

const getGuaranteedCreditLimitValue = ({
    creditCard,
    category,
}: ContentProps) => {
    if (
        category === CreditCardProductCategory.BalanceTransfer &&
        creditCard.balanceTransferComboLimit
    ) {
        return creditCard.balanceTransferComboLimit
    }
    return creditCard.guaranteedRate.guaranteedCreditLimit
}

const minimumGuaranteedCreditLimitContent = ({
    creditCard,
    category,
}: ContentProps) => {
    const value = getMinimumGuaranteedCreditLimitValue({ creditCard, category })
    const isCounterOffer = creditCard.guaranteedRate?.isCounterOffer ?? false

    const guaranteedCreditLimit = getGuaranteedCreditLimitValue({
        creditCard,
        category: CreditCardProductCategory.BalanceTransfer,
    })

    return guaranteedCreditLimit != null
        ? {
              title: isCounterOffer
                  ? `Min. Credit Limit\n*lower than requested`
                  : 'Min. Credit Limit',
              value: `${getFormattedCurrency(value)}${isCounterOffer ? '*' : ''}`,
              detailType: ProductDetailType.GuaranteedCreditLimit,
          }
        : null
}

export default minimumGuaranteedCreditLimitContent
